/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GnlList } from '../../models/gnl-list';
import { SortDirection } from '../../models/sort-direction';

export interface SearchGnl$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the station's name
 */
  sortFieldName?: 'NAME';

/**
 * The date time for the tank level
 */
  levelDateTime?: string;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search GNL
     */
    body?: any
}

export function searchGnl$Any(http: HttpClient, rootUrl: string, params?: SearchGnl$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<GnlList>> {
  const rb = new RequestBuilder(rootUrl, searchGnl$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('levelDateTime', params.levelDateTime, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GnlList>;
    })
  );
}

searchGnl$Any.PATH = '/custom/dashboard/gnl/search';
